export default class About {
    namespace = 'about'
    beforeEnter = function () {
        console.log('ABOUT SCRIPT!');
        document.querySelector('.header').classList.remove('before-loading')
    }
}